import React, { useState, useEffect, useMemo } from "react";
import Card from "../../components/Card";
import { useNavigate } from "react-router-dom";
import { Row, Col, OverlayTrigger, Tooltip, Button, Badge } from 'react-bootstrap'
import { FaEdit, FaCheckCircle } from "react-icons/fa";
import RegistrasiService from "../../services/registrasi/RegistrasiService";
import DataTable from "react-data-table-component";

// ── Mapping STATUS -> label & warna badge ──
const STATUS_MAP = {
  "0": { label: "Menunggu Verifikasi", variant: "warning" },
  "2": { label: "Aktif",               variant: "success" },
  "9": { label: "Ditolak/Ditunda",     variant: "danger"  },
};

const StatusBadge = ({ status }) => {
  const info = STATUS_MAP[status] || { label: status || "-", variant: "secondary" };
  return <Badge bg={info.variant}>{info.label}</Badge>;
};

const Traders = () => {
  let RegService = useMemo(() => new RegistrasiService(), []);
  const [traders, setTraders] = useState([]);
  const [filterRecord, setFilterRecord] = useState([])

  const navigate = useNavigate();

  // ── Buka edit-trader dalam mode 'verifikasi' (trader masih pending) ──
  const goVerifikasi = (kdTrader) => {
    localStorage.removeItem('editTraderStorage')
    localStorage.setItem('editTraderStorage', kdTrader)
    localStorage.setItem('editTraderMode', 'verifikasi')
    navigate('/setting/edit-trader')
  }

  // ── Buka edit-trader dalam mode 'edit' (trader sudah aktif) ──
  const goEdit = (kdTrader) => {
    localStorage.removeItem('editTraderStorage')
    localStorage.setItem('editTraderStorage', kdTrader)
    localStorage.setItem('editTraderMode', 'edit')
    navigate('/setting/edit-trader')
  }

  const columns = [
    {
      name: "KODE TRADER",
      selector: row => row.KODE_TRADER,
    },
    {
      name: "NAMA",
      selector: row => row.NAMA,
    },
    {
      name: "NPWP",
      selector: row => row.NPWP,
    },
    {
      name: "EMAIL",
      selector: row => row.EMAIL,
    },
    {
      name: "TELEPON",
      selector: row => row.TELEPON,
    },
    {
      name: "NAMA USER",
      selector: row => row.tb_users[0]?.NAMA,
    },
    {
      name: "STATUS",
      cell: row => <StatusBadge status={row.STATUS} />,
    },
    {
      name: "ACTION",
      cell: row => <div className="flex align-items-center list-user-action">
        <div className="col-sm-4">
          {row.STATUS === "0" ? (
            <OverlayTrigger placement="bottom" overlay={<Tooltip>Verifikasi Permohonan</Tooltip>}>
              <Button size="sm" variant="success" onClick={() => goVerifikasi(row.KODE_TRADER)}>
                <FaCheckCircle />
              </Button>
            </OverlayTrigger>
          ) : (
            <OverlayTrigger placement="bottom" overlay={<Tooltip>Edit Trader</Tooltip>}>
              <Button size="sm" variant="warning" onClick={() => goEdit(row.KODE_TRADER)}>
                <FaEdit />
              </Button>
            </OverlayTrigger>
          )}
        </div>
      </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];

  useEffect(() => {
    getTraders();
  }, []);

  useEffect(() => {
    let roleUser = localStorage.getItem('role')
    if (roleUser !== "1" && roleUser !== "2" && roleUser !== "3" && roleUser !== "7") {
      navigate('/dashboard')
    }
  }, [navigate]);

  const getTraders = async () => {
    const kd_upt = localStorage.getItem('kdUnit');

    // Daftar kode yang tidak memerlukan filter (menampilkan semua)
    const bypassCodes = ['00.1', '00.2', '00.3'];

    // Kirim parameter hanya jika ada kd_upt DAN bukan bagian dari bypassCodes
    const shouldFilter = kd_upt && !bypassCodes.includes(kd_upt);

    try {
      const response = await RegService.getAllTrader(shouldFilter ? kd_upt : null);
      setTraders(response.data);
      setFilterRecord(response.data);
    } catch (error) {
      console.error("Gagal mengambil data:", error);
    }
  };

  const handleFilter = (event) => {
    const newData = filterRecord.filter(row => row["NAMA"].toLowerCase().includes(event.target.value.toLowerCase()))
    setTraders(newData)
  }

  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header d-flex justify-content-between>
              <Row>
                <Col sm="6">
                  <div className="header-title">
                    <h4 className="card-title">Daftar Trader</h4>
                  </div>
                </Col>
                <Col sm="6">
                  <div className="input-group search-input">
                    <span className="input-group-text" id="search-input">
                      <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="11.7669" cy="11.7666" r="8.98856" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></circle>
                        <path d="M18.0186 18.4851L21.5426 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                    </span>
                    <input
                      type="search"
                      className="form-control"
                      placeholder="Search..."
                      onChange={handleFilter}
                    />
                  </div>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <DataTable
                columns={columns}
                data={traders}
                pagination
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Traders;